<template>
    <div v-if="activityInfo"
        :class="['pullNewHome', { inApp: $root.$data.isApp }]"
        :style="{background: 'url(' + activityInfo.activityBackgroundPicture + ') repeat'}"
    >
        <CommonTitle :titleName="activityInfo.activityName"/>
        <Banner :activityInfo="activityInfo" />
        <Rule :activityRule="activityInfo.activityRule"/>
        <div class="helpList">
          <img class="helpListTitle" src="../../../assets/img/pullNew/helpListTitle.png" alt="">
          <div class="tableTitle">
            <p class="oneLine">编号</p>
            <p>用户信息</p>
          </div>
          <ul v-if="helpList.length" class="helpBox">
            <li
              class="helpItem"
              v-for="(item,index) in helpList"
              :key="index"
            >
              <p class="oneLine">{{index+1}}</p>
              <p class="lastLine">
                <img :src="item.assistanceUserAvatar ? item.assistanceUserAvatar : require('../../../assets/img/personalImg/defaultAvatar.png')" alt="">
                <span>{{item.assistancePhone}}</span>
              </p>
            </li>
          </ul>
          <div class="noHelp" v-else>
            <img src="../../../assets/img/pullNew/noHelpListIcon.png" alt="">
            <p>快去邀请好友帮你助力吧～</p>
          </div>
        </div>
        <Recommend :activityId="activityId" />
        <AppDown v-if="!(this.$root.ytMini||this.$root.pullNewType===2)"/>
    </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { getPullNewInfoApi } from '@/api/pullNew';
// import QRCode from 'qrcode';

import CommonTitle from '@/components/header/CommonTitle.vue';
import Banner from '../components/banner.vue';
import Rule from '../components/rule.vue';
import AppDown from '../components/appDown.vue';
import Recommend from '../components/recommends.vue';

export default {
  components: {
    CommonTitle,
    Banner,
    Rule,
    AppDown,
    Recommend,
  },
  data() {
    return {
      activityId: null,
      activityInfo: null,
      helpList: [],
    };
  },
  methods: {
    async getActivityInfo() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      const info = await getPullNewInfoApi(this.activityId, this.$route.query.preview || 0);
      this.$toast.clear();
      const { code, data, msg } = info;
      if (code === 0) {
        this.activityInfo = data;
        this.helpList = data.pullNewActivityAssistanceDataList ?? [];
        if (this.$root.$data.isApp) document.title = data.activityName;
      } else {
        this.$toast.fail(msg);
      }
    },
    createImg() {
      // 判断登录状态
      this.$refs.canvasImg.createImg();
    },
  },
  mounted() {
    this.getActivityInfo();
     if (this.$root.ytMini || this.$root.pullNewType === 2) {
      document.title = '云图书吧';
    }
  },
  created() {
    const { activityId } = this.$route.query;
    this.activityId = activityId;
  },
};
</script>
<style scoped lang="scss">
.pullNewHome {
  min-height: 100vh;
  padding: 100px 0 200px;
  &.inApp{
    padding-top: 0;
  }
  .helpList {
    box-sizing: border-box;
    width: 686px;
    min-height: 300px;
    margin: 49px auto 0;
    padding: 0 32px 32px;
    background: #fff;
    border-radius: 40px;
    .helpListTitle {
      display: block;
      width: 474px;
      height: 102px;
      margin: 0 auto 40px;
    }
    .tableTitle {
      display: flex;
      align-items: center;
      width: 100%;
      height: 66px;
      color: #fff;
      font-size: 32px;
      background: #FF7F41;
      border-radius: 39px;
    }
    .oneLine {
        width: 45%;
        text-align: center;
    }
    .helpBox {
      max-height: 540px;
      overflow-y: scroll;
    }
     ::-webkit-scrollbar{
        display: none;
    }
    .helpItem {
      display: flex;
      align-items: center;
      height: 120px;
      font-size: 28px;
      border-bottom: 2px solid #F8F8F8;
      .lastLine {
        display: flex;
        align-items: center;
        height: 100%;
        img {
          width: 56px;
          height: 56px;
          margin-right: 32px;
          border-radius: 50%;
        }
      }
    }
    .helpItem:last-child {
      border-bottom: none;
    }
    .noHelp {
      display: flex;
      flex-flow: column;
      align-items: center;
      margin: 80px 0;
      img {
        width: 400px;
      }
      p {
        margin-top: 10px;
        color: #999;
        font-size: 28px;
      }
    }
  }
}
</style>
